import Contact from "theme/pages/Contact";

export default Contact;

const ONE_HOUR = 60 * 60;
Contact.cacheControlDefinition = {
  sMaxAge: ONE_HOUR,
  staleWhileRevalidate: ONE_HOUR * 24,
};
